import { render } from "./ListBackAccounts.vue?vue&type=template&id=20c23258&ts=true"
import script from "./ListBackAccounts.vue?vue&type=script&lang=ts"
export * from "./ListBackAccounts.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__